import React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import Pagination from "../components/newComponents/pagination";
import Card from "../components/newComponents/card";
import SectionHead from "../components/newComponents/sectionHead";
import { useParams } from "react-router";
import { HandleQuery, NewsletterListingData } from "../queries";
import { useQuery } from "@apollo/client";

export function NewslettersListing() 
{
    let { page } = useParams();
    
    page = parseInt(page ?? 1);
    const perPage = 12;
    const offset = (page - 1) * perPage;

    const query_state = useQuery(NewsletterListingData(perPage, offset), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 
    const { newsletters, all } = data;
    
    const base = "/newsletters";
    const nextUrl = Math.ceil(all.length / 12) > page ? `${base}/page/${page + 1}` : null;
    const prevUrl = page > 1 ? page - 1 === 1 ? `${base}` : `${base}/page/${page - 1}` : null;

    return(
  <Layout>
    <Seo title="Newsletters" />
    <div className="main">
      <section className="section-boxes section-boxes--news section-boxes--news-secondary">
        <div className="shell">
          <SectionHead title="Newsletters" />
          <div className="boxes boxes--news swiper-container js-slider-boxes-news">
            <ul>
              {newsletters.map((item, i) => (
                <Card key={`newsletters-listing-${i}`} image={item.featureImage[0]} ar={11/4} title={item.displayTitle} subtitle={item.summary} href={`/${item.uri}`}/>
              ))}
            </ul>
            <div className="swiper-pagination boxes__pagination" />
          </div>
          {all.length > 1 &&
            <Pagination nextUrl={nextUrl} prevUrl={prevUrl} currentPage={page} base={base} totalPages={Math.ceil(all.length / 12)}/>
          }
        </div>
      </section>
    </div>
  </Layout>
);
}
